import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit*3,
  },
  estimateAmount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  description: {
    marginRight: theme.spacing.unit*2,
    minWidth: '350px',
  },
  title: {
    flexGrow: 1,
    minWidth: '300px',
  },
  simpleAmount: {
    marginLeft: theme.spacing.unit*2,
  },
});

const Estimate = ({ classes, task, handleChange }) => {
  return(
    <Card className={classes.root}>
      <CardContent>
        <div className={classes.row}>
          <TextField
            className={classes.title}
            id="title"
            label="Title"
            placeholder="Enter title"
            margin="normal"
            value={task.title}
            onChange={ event => handleChange("title", event.target.value)}
          />
          {task.type === "simple" &&
            <TextField
              className={classes.simpleAmount}
              id="estimateAmount"
              label="Estimate Amount"
              margin="normal"
              value={task.estimate}
              onChange={ event => handleChange("estimate", event.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          }
        </div>
        {task.type === "estimate" &&
          <div className={classes.row}>
            <TextField
              className={classes.description}
              id="description"
              label="Description"
              multiline
              rows="6"
              placeholder="Describe the task"
              margin="normal"
              value={task.description}
              onChange={ event => handleChange("description", event.target.value)}
            />
            <div className={classes.estimateAmount}>
              <TextField
                id="estimateAmount"
                type="number"
                label="Estimate Amount"
                className={classes.textField}
                margin="normal"
                value={task.estimate}
                onChange={ event => handleChange("estimate", event.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
              />
            </div>
          </div>
        }
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(Estimate);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Tasks/Estimate.jsx